import React, { MouseEventHandler, useCallback } from 'react';
import { TButtonProps } from 'components/types/Button';
import TendUIButton from 'components/TendUI/Button/Button';
import { TButtonExternalProps } from 'components/types/Button/external';
import { downloadFileByLink } from 'helpers/file';

const style: React.CSSProperties = { whiteSpace: 'nowrap' };

const Button: React.FC<React.PropsWithChildren<TButtonProps>> = ({
  href,
  onClick,
  ...props
}) => {
  const onClickInternal: MouseEventHandler<HTMLButtonElement> = useCallback(
    e => {
      if (href) downloadFileByLink('', href);

      onClick?.(e);
    },
    [onClick, href],
  );

  return (
    <TendUIButton
      variant='secondary'
      type='button'
      style={style}
      {...(props as TButtonExternalProps<'button'>)}
      onClick={onClickInternal}
    />
  );
};

export default Button;
